module.exports = __webpack_public_path__ + "static/media/ceilings_lcs_60yd_n.a12d7b14.csv";